<template>
  <div class="supervisor-dashboard space-y-4">
    <!-- Header -->
    <div class="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl p-6 text-white shadow-lg">
      <h2 class="text-xl font-bold mb-2">🎭 Animation Repas</h2>
      <p class="text-sm opacity-90">Service du midi</p>
    </div>

    <!-- Appréciation globale -->
    <div class="bg-white rounded-xl p-4 shadow-sm">
      <h3 class="font-bold text-gray-800 mb-3">😊 Appréciation globale</h3>
      <div class="flex justify-around mb-3">
        <button
          v-for="(emoji, idx) in emojis"
          :key="idx"
          @click="globalRating = idx + 1"
          :class="{ 'scale-110': globalRating === idx + 1, 'opacity-50': globalRating !== idx + 1 }"
          class="text-4xl hover:scale-110 transition"
        >
          {{ emoji }}
        </button>
      </div>
      <button v-if="globalRating" class="w-full bg-green-500 text-white rounded-lg py-3 font-semibold">
        {{ getRatingLabel(globalRating) }}
      </button>
    </div>

    <!-- Détail par plat -->
    <div class="space-y-3">
      <h3 class="font-bold text-gray-800">🍽️ DÉTAIL PAR PLAT</h3>

      <div v-for="(dish, idx) in dishes" :key="idx" class="bg-white rounded-xl p-4 shadow-sm">
        <h4 class="font-semibold text-gray-800 mb-2">{{ dish.name }}</h4>
        <div class="flex gap-1 mb-2">
          <div v-for="(emoji, i) in emojis" :key="i" class="flex-1 text-center">
            <div class="text-xl">{{ emoji }}</div>
            <div class="text-xs font-semibold text-gray-600">{{ dish.ratings[i] }}%</div>
          </div>
        </div>
        <p v-if="dish.comment" class="text-sm text-gray-600 italic mt-2">💬 {{ dish.comment }}</p>
      </div>
    </div>

    <!-- Contexte -->
    <div class="bg-white rounded-xl p-4 shadow-sm">
      <h3 class="font-bold text-gray-800 mb-3">🌤️ CONTEXTE</h3>
      <div class="space-y-2">
        <div class="flex items-center justify-between">
          <span class="text-gray-600">Météo</span>
          <span class="flex items-center gap-2">
            <span>{{ weatherIcon }}</span>
            <span class="font-semibold">{{ weatherLabel }}</span>
          </span>
        </div>
        <div class="flex items-center justify-between">
          <span class="text-gray-600">Bruit</span>
          <div class="flex gap-1">
            <div
              v-for="i in 5"
              :key="i"
              :class="i <= noiseLevel ? 'bg-orange-500' : 'bg-gray-200'"
              class="w-6 h-6 rounded"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-2 gap-3">
      <button
        @click="addComment"
        class="bg-blue-500 hover:bg-blue-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
      >
        💬 Commentaire
      </button>
      <button
        @click="takePhoto"
        class="bg-purple-500 hover:bg-purple-600 text-white rounded-lg p-4 font-semibold shadow-md transition flex items-center justify-center gap-2"
      >
        📸 Photo
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupervisorDashboard",
  data() {
    return {
      emojis: ["😞", "😕", "😐", "😊", "😍"],
      globalRating: null,
      noiseLevel: 3,
      weatherIcon: "☀️",
      weatherLabel: "Ensoleillé 22°C",
      dishes: [
        {
          name: "Poulet rôti",
          ratings: [3, 7, 20, 40, 30],
          comment: '"Trop sec"',
        },
        {
          name: "Riz",
          ratings: [5, 15, 30, 35, 15],
          comment: '"Portion trop grande"',
        },
        {
          name: "Haricots verts",
          ratings: [3, 7, 20, 45, 25],
          comment: "",
        },
        {
          name: "Yaourt",
          ratings: [2, 3, 15, 40, 40],
          comment: "",
        },
      ],
    }
  },
  methods: {
    getRatingLabel(rating) {
      const labels = ["Très mauvais", "Mauvais", "Correct", "Très bien", "Excellent"]
      return labels[rating - 1]
    },
    addComment() {
      alert("Ajout de commentaire")
    },
    takePhoto() {
      alert("Prise de photo")
    },
  },
}
</script>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}
.space-y-3 > * + * {
  margin-top: 0.75rem;
}
.space-y-2 > * + * {
  margin-top: 0.5rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.grid {
  display: grid;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1 1 0%;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-orange-500 {
  --tw-gradient-from: #f97316;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded {
  border-radius: 0.25rem;
}
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
.shadow-md {
  box-shadow: 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.shadow-lg {
  box-shadow: 0 4px 6px -4px rgb(0 0 0 / 0.1);
}
.bg-white {
  background-color: #ffffff;
}
.bg-orange-500 {
  background-color: #f97316;
}
.bg-gray-200 {
  background-color: #e5e7eb;
}
.bg-green-500 {
  background-color: #22c55e;
}
.bg-blue-500 {
  background-color: #3b82f6;
}
.bg-blue-600 {
  background-color: #2563eb;
}
.hover\:bg-blue-600:hover {
  background-color: #2563eb;
}
.bg-purple-500 {
  background-color: #a855f7;
}
.bg-purple-600 {
  background-color: #9333ea;
}
.hover\:bg-purple-600:hover {
  background-color: #9333ea;
}
.text-white {
  color: #ffffff;
}
.text-gray-600 {
  color: #4b5563;
}
.text-gray-800 {
  color: #1f2937;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-center {
  text-align: center;
}
.italic {
  font-style: italic;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.w-full {
  width: 100%;
}
.w-6 {
  width: 1.5rem;
}
.h-6 {
  height: 1.5rem;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-90 {
  opacity: 0.9;
}
.scale-110 {
  transform: scale(1.1);
}
.hover\:scale-110:hover {
  transform: scale(1.1);
}
.transition {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
button {
  cursor: pointer;
  border: none;
  background: none;
}
button:hover {
  opacity: 0.9;
}
</style>
